import { odooProductsClient, withLocale } from '@/odooClient';

const fetchAppCategory = async (handle) => {
  const [category] = await odooProductsClient.request('call', {
    service: 'object',
    method: 'execute_kw',
    args: [
      'product.category',
      'search_read',
      [[
        ['is_app_category', '=', true],
        ['handle', '=', handle],
      ]],
      withLocale({ fields: ['id', 'name'] }),
    ],
  });

  return category ?? null;
};

const fetchCategoryDefaultProducts = async (category) => odooProductsClient.request('call_kw', {
  service: 'object',
  method: 'execute_kw',
  args: [
    'product.product',
    'search_read',
    [[
      ['default_variant', '=', true],
      ['categ_id', '=', category.id],
    ]],
    withLocale({
      fields: ['id', 'categ_id'],
    }),
  ],
});

export default async function resolveFirstModelRoute(handle, routeName) {
  const category = await fetchAppCategory(handle);

  if (!category) {
    return { name: 'dashboard' };
  }

  const [product] = await fetchCategoryDefaultProducts(category);

  if (!product) {
    return { name: 'dashboard' };
  }

  return {
    name: routeName,
    params: {
      category: product.categ_id[0],
      product: product.id,
    },
  };
}
